import { BASE_URL } from '@constants/api'
import {
	TopAccessedRequest,
	TopAccessedResponse,
} from '@models/mostAccessed.model'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { setAuthorization } from '@utils/helpers'

export const mostAccessedApi = createApi({
	reducerPath: 'mostAccessed',
	tagTypes: ['MostAccessed'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: setAuthorization,
	}),
	endpoints: (builder) => ({
		getTopAccessed: builder.query<TopAccessedResponse, TopAccessedRequest>({
			query: ({ month = '', year = '' }) => ({
				url: `/top-accessed-contents`,
				method: 'GET',
				params: {
					year,
					month,
				},
			}),
			providesTags: ['MostAccessed'],
		}),
	}),
})

export const { useGetTopAccessedQuery } = mostAccessedApi
